import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { SIDEBAR_LIST } from './constants';
import Modalv2 from '../../Components/Modalv2';
import { Modalv2Context } from '../../Contexts/Modalv2Context';
import GeneralSettings from './GeneralSettings';
import ScriptsConfig from './ScriptsConfig';
import SplitConfig from './SplitConfig';
import useSplitDoc from '../../CustomHooks/useSplitDoc';
import ConfigEditorMainPage from '../../Components/ConfigEditorMainPage';
import GeneralButton from '../../Components/GeneralButton';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
import { Typography } from '@mui/material';
import FinalOverview from './FinalOverview';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

const { GENERAL_SETTINGS, SCRIPTS_SETTINGS, SPLIT_CONFIGS_SETTINGS } = SIDEBAR_LIST;

const SplitDocConfigGenerator = () => {
	const { updateModalContent } = useContext(Modalv2Context);

	const { siteId } = useParams();
	const {
		splitDoc,
		updateSplitDoc,
		splitDocEditMode,
		getSplitDocWithEncodedScripts,
		previousSplitDoc
	} = useSplitDoc(siteId, true);
	const commonProps = {
		splitDoc,
		updateSplitDoc,
		splitDocEditMode
	};

	const settingConfigs = {
		[GENERAL_SETTINGS.SETTING_NAME]: <GeneralSettings {...commonProps} />,
		[SCRIPTS_SETTINGS.SETTING_NAME]: <ScriptsConfig {...commonProps} />,
		[SPLIT_CONFIGS_SETTINGS.SETTING_NAME]: <SplitConfig {...commonProps} />
	};

	const sidebarConfig = [
		{
			icon: <LanguageOutlinedIcon fontSize="medium" />,
			label: GENERAL_SETTINGS.LABEL,
			settingName: GENERAL_SETTINGS.SETTING_NAME
		},
		{
			icon: <CodeOutlinedIcon fontSize="medium" />,
			label: SCRIPTS_SETTINGS.LABEL,
			settingName: SCRIPTS_SETTINGS.SETTING_NAME
		},
		{
			icon: <CallSplitOutlinedIcon fontSize="medium" />,
			label: SPLIT_CONFIGS_SETTINGS.LABEL,
			settingName: SPLIT_CONFIGS_SETTINGS.SETTING_NAME
		},
		{
			isButton: true,
			button: (
				<GeneralButton
					system={SYSTEMS.SPLIT_DOC}
					name="SPLIT_DOC_OPEN_FINAL_OVERVIEW_MODAL_BUTTON"
					color="primary"
					variant="contained"
					size="medium"
					onClick={() =>
						updateModalContent(
							<FinalOverview
								getSplitDocWithEncodedScripts={getSplitDocWithEncodedScripts}
								splitDocEditMode={splitDocEditMode}
								previousSplitDoc={previousSplitDoc}
							/>
						)
					}
				>
					<Typography fontWeight="bold">Final Overview</Typography>
				</GeneralButton>
			)
		}
	];

	return (
		<>
			<ConfigEditorMainPage
				sidebarConfig={sidebarConfig}
				settingConfigs={settingConfigs}
				system={SYSTEMS.SPLIT_DOC}
				isLoading={!splitDoc}
			/>
			<Modalv2 />
		</>
	);
};
export default SplitDocConfigGenerator;
